// 开发环境配置项

module.exports = {
  jsonPath: '/',
  serverUrl: 'http://192.168.2.41:9527',
  imgPathWater: 'http://192.168.2.205/images', // 图片资源前缀
};
